module.exports = "<!-- intentionally blank -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adfs-redirect/adfs-redirect.component.html
// module id = 816
// module chunks = 3